"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = require("./styled");

var _links = require("../../links");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Product = function Product(_ref) {
  var url = _ref.url,
      image = _ref.image,
      label = _ref.label,
      sub = _ref.sub,
      color = _ref.color,
      id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_styled.ProductContainer, {
    href: url,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_styled.ImageContainer, null, image), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styled.ProductTitle, {
    $color: color
  }, label), /*#__PURE__*/_react.default.createElement("div", null, sub)));
};

Product.propTypes = {
  url: _propTypes.default.string.isRequired,
  image: _propTypes.default.node.isRequired,
  label: _propTypes.default.string.isRequired,
  sub: _propTypes.default.string.isRequired,
  color: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]).isRequired,
  id: _propTypes.default.string
};

var ProductMenu = function ProductMenu(_ref2) {
  var products = _ref2.products,
      disabled = _ref2.disabled,
      className = _ref2.className;
  return /*#__PURE__*/_react.default.createElement(_styled.MenuContainer, {
    disabled: disabled,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_styled.Label, {
    disabled: disabled
  }, "Products ", /*#__PURE__*/_react.default.createElement(_styled.Icon, {
    disabled: disabled
  })), /*#__PURE__*/_react.default.createElement(_styled.Dropdown, null, Object.values(_links.CUSTOMER_TYPES).map(function (type) {
    return /*#__PURE__*/_react.default.createElement(_styled.CustomerTypeColumn, {
      key: type
    }, /*#__PURE__*/_react.default.createElement(_styled.CustomerTypeTitle, null, type, /*#__PURE__*/_react.default.createElement(_styled.Line, null)), products.filter(function (product) {
      return product.customer === type;
    }).map(function (product) {
      return /*#__PURE__*/_react.default.createElement(Product, {
        key: product.label,
        url: product.url,
        image: product.img,
        label: product.label,
        sub: product.sub,
        color: product.color,
        id: product.id
      });
    }));
  })));
};

ProductMenu.propTypes = {
  products: _propTypes.default.array.isRequired,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = ProductMenu;
exports.default = _default;